import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import PropTypes from 'prop-types';
import Header from './Header';
import BottomNav from './BottomNav';
import PrivateRoute from './Routes';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Switch } from 'react-router';
import { bindActionCreators } from 'redux';
import { ContactsApiProvider } from 'services';
import CustomModal from '../common/modals/CustomModal';
import _ from 'lodash';
import ReadLoader from '../common/loaders/ReadLoader';
import WriteLoader from '../common/loaders/WriteLoader';
import { toggleWriteLoader, customModalActions, bottomnavActions, logout } from 'actions';

import SideMenu from './SideMenu';
import Appointments from 'components/appointments';
import Dashboard from 'components/dashboard';
import LeadAcceptance from 'components/leadAcceptance';
import AutoAsignLeadAcceptance from 'components/leadAcceptance/AutoAssignLeadAcceptance';
import Notifications from 'components/notifications';
import Referrals from 'components/referrals';
import ReferralDetails from 'components/referrals/details';
import UserProfile from 'components/userprofile';
import OutOfOffice from 'components/userprofile/outofoffice';
import AppointmentDetails from 'components/appointments/details';
import AppointmentAction from 'components/appointments/details/AppointmentAction';
import SSO from 'components/sso';
import ForgotPassword from 'components/login/forgot.password';
import AuthService from '../../utils/authentication/auth.service';
import LinkingService from '../../services/linking.services';
import { redirectOnNotification, getNotificationCount } from '../../actions/notifications.actions';
import { updateDeviceInfo } from '../../actions/login.actions';
import { appointmentActions } from '../../actions/appointments.actions';
import { taskActions } from '../../actions';
import Tasks from 'components/tasks';
import Updates from 'components/referrals/weekly.status.update';
import TaskDetails from 'components/tasks/details';
import AzureB2CProvider from '../login/AzureB2CProvider';
import ErrorBoundary from './ErrorBoundary';
const auth = new AuthService();

class App extends React.Component {
  state = {
    isAuthenticated: false,
    isInitiated: false
  }

  static propTypes = {
    history: PropTypes.object.isRequired,
    isLoadingRead: PropTypes.bool.isRequired,
    isLoadingWrite: PropTypes.bool.isRequired,
    toggleWriteLoader: PropTypes.func.isRequired,
    userprofile: PropTypes.object.isRequired,
    customModal: PropTypes.object.isRequired,
    hideCustomModal: PropTypes.func.isRequired,
    login: PropTypes.object.isRequired,
    logout: PropTypes.func.isRequired,
    bottomnav: PropTypes.object.isRequired,
    changeActiveItem: PropTypes.func.isRequired,
    fetchAppointments: PropTypes.func.isRequired,
    getNotificationCount: PropTypes.func.isRequired,
    appointments: PropTypes.object.isRequired,
    fetchTasks: PropTypes.func.isRequired
  };

  static getDerivedStateFromProps (props, state) {
    if (!props.userprofile.memberKey) { props.loadSession(); }
    if (auth.isAuthenticated() && props.userprofile.memberKey && props.login.isTermsAccepted) {
      state.isAuthenticated = true;
      if (!state.isInitiated) {
        state.isInitiated = true;
        props.fetchAppointments();
        props.getNotificationCount();
        props.fetchTasks();
      }
    } else {
      state.isAuthenticated = false;
    }
    return state;
  }

  componentWillUnmount () {
    LinkingService.removeEventListeners();
  }

  render () {
    const props = this.props;
    const showHeader = _.get(this.props, 'header.showHeader', true);
    const currentPath = this.props.history?.location?.pathname || '';
    const showFooterWithBackButton = _.get(this.props, 'header.showFooterWithBackButton', false);
    const routesWithoutFooter = [
      '/userprofile'
    ];
    const noFooter = routesWithoutFooter.includes(currentPath) ||
    (!showFooterWithBackButton && (!showHeader || _.get(this.props, 'header.hasBackButton', false)));

    return (
      <ConnectedRouter history={this.props.history}>
        <ErrorBoundary>
          <Switch>
            <React.Fragment>
              <div className='wrapper'>
                <SideMenu
                  changeActiveItem={props.changeActiveItem}
                  activeItem={props.bottomnav.activeItem}
                  memberFullName={props.userprofile.memberFullName}
                  items={props.bottomnav.items}
                  logout={props.logout}
                />
                <div className='main-content'>
                  {
                    showHeader && <Header />
                  }
                  <ReadLoader isLoading={props.isLoadingRead} className={_.get(this.props, 'header.headerClassName', '')} />
                  <PrivateRoute path='/dashboard' component={Dashboard} />
                  <PrivateRoute path='/appointments' component={Appointments} />
                  <PrivateRoute path='/appointmentdetails/:appointmentId' component={AppointmentDetails} />
                  <PrivateRoute path='/appointmentaction/:actionName/:appointmentId' component={AppointmentAction} />
                  <PrivateRoute path='/leadacceptance/:contactId/opportunity/:opportunityId/appointment/:appointmentId/' component={LeadAcceptance} />
                  <PrivateRoute path='/autoacceptlead/:contactId/opportunity/:opportunityId/appointment/:appointmentId/' component={AutoAsignLeadAcceptance} />
                  <PrivateRoute path='/notifications' component={Notifications} />
                  <PrivateRoute path='/userprofile' exact component={UserProfile} />
                  <PrivateRoute path='/userprofile/outofoffice' exact component={OutOfOffice} />
                  <PrivateRoute path='/referrals' component={Referrals} />
                  <PrivateRoute path='/referraldetails/:referralId/' exact component={ReferralDetails} />
                  <PrivateRoute path='/referraldetails/:referralId/appointment/:appointmentId' exact component={ReferralDetails} />
                  <PrivateRoute path='/referraldetails/:referralId/:showUserRatingPopup' exact component={ReferralDetails} />
                  <PrivateRoute path='/tasks' exact component={Tasks} />
                  <PrivateRoute path='/taskdetails/:taskId' exact component={TaskDetails} />
                  <PrivateRoute path='/statusupdates/:contactId/:opportunityId' exact component={Updates} />
                  {
                    !noFooter &&
                    <BottomNav changeActiveItem={props.changeActiveItem} activeItem={props.bottomnav.activeItem} items={props.bottomnav.items} />
                  }
                </div>
              </div>
              <Route exact path='/' render={() => this.state.isAuthenticated ? <Redirect to='/dashboard' /> : <AzureB2CProvider action='login' />} />
              <Route path='/azureb2c' render={() => <AzureB2CProvider action='login' />} />
              <Route path='/azureb2clogout' render={() => <AzureB2CProvider action='logout' />} />
              <Route path='/login' render={() => this.state.isAuthenticated ? <Redirect to='/dashboard' /> : <AzureB2CProvider action='login' />} />
              <Route path='/sso/:ssotoken' component={SSO} />
              <Route path='/forgotpassword' component={ForgotPassword} />
              <WriteLoader isLoading={props.isLoadingWrite} toggleLoader={props.toggleWriteLoader} />
              <CustomModal hideModal={props.hideCustomModal} {...props.customModal} />
            </React.Fragment>
          </Switch>
        </ErrorBoundary>
      </ConnectedRouter>
    );
  }
}

const mapStateToProps = (state) => {
  const { header = {}, userprofile = {}, modals = {}, login = {}, bottomnav = {}, appointments = {} } = state;
  return {
    login,
    header,
    userprofile,
    bottomnav,
    appointments,
    isLoadingRead: header.isLoadingRead,
    isLoadingWrite: header.isLoadingWrite,
    customModal: { ...modals.customModal }
  };
};

const mapDispatchToProps = dispatch => ({
  loadSession: bindActionCreators(ContactsApiProvider.loadSession, dispatch),
  toggleWriteLoader: bindActionCreators(toggleWriteLoader, dispatch),
  hideCustomModal: bindActionCreators(customModalActions.hideCustomModal, dispatch),
  changeActiveItem: bindActionCreators(bottomnavActions.changeActiveItem, dispatch),
  logout: bindActionCreators(logout, dispatch),
  redirectOnNotification: bindActionCreators(redirectOnNotification, dispatch),
  updateDeviceInfo: bindActionCreators(updateDeviceInfo, dispatch),
  fetchAppointments: bindActionCreators(appointmentActions.fetch, dispatch),
  getNotificationCount: bindActionCreators(getNotificationCount, dispatch),
  fetchTasks: bindActionCreators(taskActions.fetchTasks, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
